import { render, staticRenderFns } from "./RequestStudyPlanPopUp.vue?vue&type=template&id=40463934&scoped=true"
import script from "./RequestStudyPlanPopUp.vue?vue&type=script&lang=js"
export * from "./RequestStudyPlanPopUp.vue?vue&type=script&lang=js"
import style0 from "./RequestStudyPlanPopUp.vue?vue&type=style&index=0&id=40463934&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40463934",
  null
  
)

export default component.exports